(function() {
    'use strict';

    angular
        .module('valueconnectApp')
        .controller('BlackoutPeriodController', BlackoutPeriodController);

    BlackoutPeriodController.$inject = ['$scope', '$state', 'BlackoutPeriod'];

    function BlackoutPeriodController ($scope, $state, BlackoutPeriod) {
        var vm = this;

        vm.blackoutPeriods = [];
        vm.loadAll = loadAll;
        vm.search = search;
        vm.searchFilter = searchFilter;
        vm.searchQuery = '';
        vm.appliedQuery = '';

        loadAll();

        function loadAll() {
            BlackoutPeriod.query(function(result) {
                vm.blackoutPeriods = result;
            });
        }

        // Commit the typed query. Filtering only happens on submit (Search button or Enter), like the
        // report pages — not live as the user types.
        function search() {
            vm.appliedQuery = vm.searchQuery;
        }

        // Client-side filter over the loaded rows. Matches the committed query against the appraiser's
        // name, email and firm only (not id/dates), case-insensitively.
        function searchFilter(blackoutPeriod) {
            if (!vm.appliedQuery) {
                return true;
            }
            var query = vm.appliedQuery.toLowerCase();
            var haystack = [
                blackoutPeriod.firstName,
                blackoutPeriod.lastName,
                blackoutPeriod.email,
                blackoutPeriod.appraiserFirmName
            ].join(' ').toLowerCase();
            return haystack.indexOf(query) !== -1;
        }
    }
})();
